<common-navigation></common-navigation>

<div class="default-box d-flex align-items-center mx-auto col-md-5 col-lg-5">
  <div class="container">
    <div class="d-flex justify-content-center align-items-center" *ngIf="loading">
      <img src="../../../../assets/images/loader-big.svg">
    </div>
    <div class="row">
      <!-- ERROR -->
      <div class="col-lg-12 col-xl-12 d-flex justify-content-center align-items-center" *ngIf="error && !loading">
        <h3 class="display-4 box-title">Account Error</h3>
      </div>
      <div class="col-lg-12 col-xl-12 mt-md-3 mt-3 d-flex justify-content-center align-items-center"
        *ngIf="error && !loading">
        <p>Activation request could not be completed.</p>
      </div>

      <!-- SUCCESS -->
      <div class="col-lg-12 col-xl-12 d-flex justify-content-center align-items-center" *ngIf="success && !loading">
        <h3 class="display-4 box-title">Account Activated</h3> <br>
      </div>
      <div class="col-lg-12 col-xl-12 d-flex justify-content-center align-items-center mt-md-3 mt-3"
        *ngIf="success && !loading">
        <p class="text-center">Your account was successfully activated! You can now
          login with the email and password you provided when
          you
          signed up.
        </p>
      </div>
      <div class="col-lg-12 col-xl-12 d-flex justify-content-center align-items-center mt-md-3 mt-3"
           *ngIf="success && !loading">
        <p class="text-center">
          <button type="button" class="btn btn-primary px-5 btn-submit" routerLink="/sign-in">
            Login
          </button>
        </p>
      </div>
    </div>
  </div>
